import { useState, useContext } from 'react'
import ResultContext from '../context/ResultContext'
import { toast } from 'react-toastify'

function SearchBar() {
  const { inventory } = useContext(ResultContext)
  const [text, setText] = useState('')

  const handleTextChange = (e) => {
    setText(e.target.value)
  }

  // const handleSubmit = (e) => {
  //   e.preventDefault()
  //   if (text === '') {
  //     // alert('Enter a Color Name')
  //     toast.error('😮 Please enter a color name')
  //   } else {
  //     const result = inventory.filter((item) => item.color === text)
  //     // do a inventory.map(item) if item === text then its a match, then display
  //     // search inventory
  //     console.log(result)
  //   }
  //   setText('')
  // }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (text === '') {
      // alert('Enter a Color Name')
      toast.error('😮 Please enter a color name')
    } else {
      const result = inventory.filter((item) => item.color === text)
      result.forEach((item) => console.log(item.color))
      // do a inventory.map(item) if item === text then its a match, then display
      // search inventory
      // console.log(result)
    }
    setText('')
  }

  return (
    <div className='w-full mb-4'>
      <form onSubmit={handleSubmit}>
        <div className='flex justify-center mx-3'>
          <input
            onChange={handleTextChange}
            type='text'
            id='colorInput'
            value={text}
            placeholder='Search a specific color here'
            className='form-input block w-full md:w-1/2 px-3 py-1.5 text-base font-normal text-gray-600 bg-white bg-clip-padding border border-solid border-gray-300 rounded-r-none rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none '
          />
          <button
            type='submit'
            className='rounded-l-none w-36 btn btn-md border border-solid border-gray-300'
          >
            GO
          </button>
        </div>
      </form>
    </div>
  )
}

export default SearchBar
